import API from 'app/services/server/serverApi'
import { getConnectionStatus } from 'app/services/database/connectionStatusResolver'
import { CreateServerModel } from 'app/models/createServerModel'
import { ServerModel } from 'app/models/serverModel'

/**
 * Zapytania serwerów, wspólne dla trzech kontenerów.
 *
 * Slice `servers` karmił zakładkę Serwery, zakładkę Firmy i modal edycji — a edycja
 * mutowała listę przez `EDIT_SERVER`. Dlatego wszystkie trzy muszą dzielić jeden klucz:
 * zapis z modalu ma odświeżyć listę pod spodem, tak jak robił to reducer.
 *
 * Klucz zawiera `companyId`, bo endpoint filtruje po firmie (`/config-api/server?
 * companyId=`), a zakładka Serwery w panelu firmowym pokazuje inny zbiór niż
 * w globalnym.
 */
export const serversKey = (companyId: string | null | undefined) =>
  ['admin', 'servers', companyId ?? null] as const

/** Mapowanie przeniesione 1:1 z thunka - m.in. `status` przechodzi przez resolver. */
export const mapServerFields = (c: any): ServerModel => ({
  id: c.id,
  name: c.name,
  login: c.login,
  password: c.password,
  localAddress: c.localAddress,
  address: c.address,
  backupLocation: c.backupLocation,
  databases: c.databases || 0,
  companies: c.companies || 0,
  status: getConnectionStatus(c.status),
  createdBy: c.createdBy,
  createdDate: c.createdDate,
  inUse: c.inUse,
  modifiedBy: c.modifiedBy,
  modifiedDate: c.modifiedDate,
  lastErrorMessage: c.lastErrorMessage,
  lastDisconnectedDate: c.lastDisconnectedDate,
  lastConnectedDate: c.lastConnectedDate,
  isPrivate: c.isPrivate,
  isDefault: c.isDefault,
})

export const fetchServers = async (
  companyId: string | null | undefined,
): Promise<ServerModel[]> => {
  const response = await API.create().getServers(companyId as string)
  return (response.content.data as any[]).map(mapServerFields)
}

export const addServerRequest = (server: CreateServerModel) =>
  API.create().addServer(server)

export const editServerRequest = (server: ServerModel) =>
  API.create().editServer(server)

export const deleteServersRequest = (ids: string[]) =>
  API.create().deleteServer(ids)

/** Kształt błędu, którego oczekują komponenty (sprawdzają `.error`). */
export const toActionError = (error: unknown) => ({
  error: (error as any)?.status?.data?.code,
})
